import { render, staticRenderFns } from "./supplier-detail-quoted-info.vue?vue&type=template&id=69ed52c3&scoped=true&"
import script from "./supplier-detail-quoted-info.vue?vue&type=script&lang=js&"
export * from "./supplier-detail-quoted-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ed52c3",
  null
  
)

export default component.exports